import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Marcus Allen",
    role: "Founder, Atlas Apparel",
    quote:
      "We tripled monthly orders within 8 weeks of launch. The site loads insanely fast and looks high-end.",
  },
  {
    name: "Priya Shah",
    role: "CMO, XLabel Sync",
    quote:
      "Hands-down the easiest agency I've ever worked with. Lead quality from the new site is night-and-day better.",
  },
  {
    name: "Diego Romero",
    role: "Operator, Orbita Bot",
    quote:
      "Pricing is transparent, work is high-end, and the team actually picks up the phone. 10/10.",
  },
  {
    name: "Sasha Williams",
    role: "Director, Nexso",
    quote:
      "Our site finally looks like the premium agency we are. Booked 5x more discovery calls in month one.",
  },
];

export default function Testimonials() {
  return (
    <section className="section-pad relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14 max-w-2xl">
          <span className="font-mono-jb text-xs uppercase tracking-[0.3em] text-[#CCFF00]">
            / Words from clients
          </span>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tighter font-bold mt-4 leading-[1.05]">
            Real businesses. <span className="text-gradient-neon">Real results.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bento-card p-8 relative"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="w-10 h-10 text-[#CCFF00]/30 absolute top-6 right-6" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, j) => (
                  <Star
                    key={j}
                    className="w-4 h-4 fill-[#CCFF00] text-[#CCFF00]"
                  />
                ))}
              </div>
              <p className="text-zinc-200 text-lg leading-relaxed">"{t.quote}"</p>
              <div className="mt-6 pt-6 border-t border-white/10">
                <div className="font-display font-bold">{t.name}</div>
                <div className="text-sm text-zinc-500">{t.role}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
